/*
Author: Liubo
Date: 2018-11-27
Desc: 框架和项目公用方法
*/
import util from "./util";
import utilJfit from "./util_jfit";
import cache from "@/assets/js/cache";

export default Object.assign(util, utilJfit);

// 是否查询全部基金（过滤风险等级不符的基金）
export function getRiskFilter() {
    const userInfo = cache.getUser();
    if (userInfo.qryallfund) {
        return userInfo.qryallfund == "0" ? "1" : "0";
    }
    return "1";
}
